import { UIText1 } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './InfoMessage.css';

type TInfoMessageProps = {
  text: string;
  icon?: React.ReactNode;
  buttons?: React.ReactElement<HTMLButtonElement>[];
};

export const InfoMessage: React.VFC<TInfoMessageProps> = ({ text, icon, buttons }) => {
  return (
    <div
      className={classNames(styles['container'], buttons?.length && styles['buttons_container'])}
      data-testid="InfoMessage"
    >
      {icon}
      <div className={styles['text']}>
        <UIText1 color="black_100">{text}</UIText1>
      </div>
      <div className={styles['buttons']}>{buttons?.map(component => component)}</div>
    </div>
  );
};
